import React from 'react'
import { createReactEditorJS } from 'react-editor-js'
import Embed from '@editorjs/embed'
import Table from '@editorjs/table'
import EditorjsList from '@editorjs/list'
import Header from '@editorjs/header'
import Quote from '@editorjs/quote'
import Marker from '@editorjs/marker'
import Delimiter from '@editorjs/delimiter'
import Undo from 'editorjs-undo'
import DragDrop from 'editorjs-drag-drop'

class CustomList extends EditorjsList {
  renderSettings() {
    return super.renderSettings().filter((item) =>
      ['Unordered', 'Ordered'].includes((item).label),
    );
  }
}

import { useState } from 'react'

const EDITOR_JS_TOOLS = {
  // NOTE: Paragraph is default tool. Declare only when you want to change paragraph option.
  // paragraph: Paragraph,
  embed: Embed,
  table: {
    class: Table,
    inlineToolbar: true,
    config: {
      rows: 2,
      cols: 3,
      withHeadings: true,
    },
  },
  list: {
    class: CustomList,
    inlineToolbar: true,
    toolbox: [
      {
        data: { style: 'ordered' },
      },
      {
        data: { style: 'unordered' },
      },
    ],
    config: {
      defaultStyle: 'unordered'
    },
  },
  header: Header,
  quote: Quote,
  marker: Marker,
  delimiter: Delimiter,
}

const ReactEditorJS = createReactEditorJS()

export default function PagesTest() {
  const [blocks, setBlocks] = useState([])
  const editorCore = React.useRef(null)

  const handleInitialize = React.useCallback((instance) => {
    editorCore.current = instance
  }, [])

  const handleReady = () => {
    const editor = editorCore.current._editorJS;
    new Undo({ editor })
    new DragDrop(editor);
  }

  const handleSave = React.useCallback(async () => {
    const savedData = await editorCore.current.save()
    console.log(savedData)
  }, [])

  return <>
    <h1>EditorJS React Component</h1>
    <ReactEditorJS
      defaultValue={blocks}
      onInitialize={handleInitialize}
      onReady={handleReady}
      tools={EDITOR_JS_TOOLS} />
    <h2>More HTML Content</h2>
    <button onClick={handleSave}>Save</button>
  </>
}
